// Override Settings : Note, custom object can't be overriden and requires direct modification
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        refineByHorizontalPosition: 'top'
    },
    selector: {
        products: '#product-loop'
    }
};

const isMObile = $(window).width() < 768 ? true:false;
// FILTER TEMPLATES
var bcSfFilterTemplate = {

    // Grid Template
    'productGridItemHtml': '<div id="{{itemProductId}}" class="product-index" data-alpha="{{itemTitle}}" data-price="{{itemPriceAttr}}">' +
        '<div class="prod-container">' +
            '{{itemBadge}}' +
            '<div class="reveal prod-image">' +
                '<a class="prod-image-link" href="{{itemUrl}}" title="{{itemTitle}}">' +
                    // '{{itemImageHtml}}' +
                    //'<img id="product-image-{{itemProductId}}" src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
                    '{{itemImageCustom}}'+
                    '{{itemFlipImage}}' + 
                '</a>' +
                '{{itemQuickview}}' +
            '</div>' +
        '</div>' +

        '<div class="product-info">' +
        //'<span class="shopify-product-reviews-badge" data-id="{{itemProductId}}"></span>'+
            '<a class="product-title-wrap" href="{{itemUrl}}"> ' +
                '{{itemVendor}}' +
                '<h3 class="product-title">{{itemTitle}}</h3>' +
            '</a>' +
            //'{{wishlistButton}}' +
            '<div class="product-price-wrap bfx-price">{{itemPrice}}</div>' +
            '{{itemSwatch}}' +
            '<div class="product-exclusion-note" data-show="{{itemShowExclude}}">{{itemLabelExclude}}</div>' +
        '</div>' +
    '</div>',

    'itemImageHtml': '<div data-color="{{itemImageAlt}}"><img id="product-image-{{itemProductId}}" src="{{itemImageUrl}}" alt="{{itemTitle}}" /></div>',

    // Badge Template
    'itemBadgeHtml': '<div class="react-badge" data-badge=\'{{badgeTags}}\'></div>',

    // Wishlist Heart Template
    'wishlistBtnHtml': '<button class="button-wishlist-product" data-on-wishlist="false" data-product-id="{{itemProductId}}" data-variant-id="{{itemVaraintId}}" aria-label="Wishlist Button">' +
        '<svg version="1.1" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 64 60.833">' +
        '<path stroke="#000" stroke-width="5" stroke-miterlimit="10" d="M45.684,2.654c-6.057,0-11.27,4.927-13.684,10.073 c-2.417-5.145-7.63-10.073-13.687-10.073c-8.349,0-15.125,6.776-15.125,15.127c0,16.983,17.134,21.438,28.812,38.231 c11.038-16.688,28.811-21.787,28.811-38.231C60.811,9.431,54.033,2.654,45.684,2.654z"></path>' +
        '</svg>' +
        '</button>',

    // Pagination Template
    'previousHtml': '<a href="{{itemUrl}}" aria-label="Previous Page"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
    'nextHtml': '<a href="{{itemUrl}}" aria-label="Next Page"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
    'pageItemHtml': '<a href="{{itemUrl}}" aria-label="{{itemTitle}}">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '{{itemTitle}}',
    'paginateHtml': '<span class="count"></span>{{previous}}{{pageItems}}{{next}}',

    // No Items In Stock Message Template
    'noItemsAvailableHtml': '<div class="no-items-msg" aria-label="No in-stock items available">We\'re sorry, there are no in-stock items available that meet the selected criteria.</div>',

    // Sorting Template
    'sortingHtml': '<h4 class="sort-label">' + bcSfFilterConfig.label.sorting + '</h4><select class="styled-select" aria-label="Select Sort">{{sortingItems}}</select>',

    // Apply Btn Template (Mobile) : Filter constructor not exposed, so func binding close not available, hence this sad click..
    'mobileApplyBtnHtml': '<div class="btn--container"><div class="mobile-apply-button-container"><button class="mobile-apply-button">Apply Filters</button></div></div>'
    //'mobileApplyBtnHtml': '<div class="btn--container"><div class="mobile-apply-button-container"><button class="mobile-apply-button" onClick="$(\'#bc-sf-filter-tree-mobile-button\').click()">Apply Filters</button></div><div id="mobile-filter-close"><button type="button"><svg class="icon icon-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><polygon fill="#fff" points="36,0.8 35.2,0 18,17.2 0.8,0 0,0.8 17.2,18 0,35.2 0.8,36 18,18.8 35.2,36 36,35.2 18.8,18 "/></svg></button></div></div>'
};

// UTILS 
var filterUtils = window.theme.utils.filterUtils;


BCSfFilter.prototype.buildProductGridItem = function (data, index, totalProduct) {
    // DATA : Prepare necessary data bits
    if(data.product_type.toLowerCase() == 'gift card' || data.product_type.toLowerCase() == 'giftcard'){
        return '';
    } else {
    var images = data.images_info;

    // Displaying price base on the policy of Shopify
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    /* HIDE ITEM : Hide if tag "hide_from_catalog" found basically 
    INFO:
        If item has tag "hide_from_catalog", skip it as its a Gift w/ Purchase item
        We can't set item unavailable on sales channels if its a gift item, so this 
        is solution for now to hide the item from store "all products catalogs"

    RESULTS COUNT NOTE :
        Page counts will be off by however hidden items there are, but since
        hidden items should have no collection tag assignments, it should only
        affect the "all products" collection and a num or two off shouldn't matter there.
    * --------------------------------------------------------------------------------------- */
    if ( data.tags ) {
        var hasHideFlag = data.tags.filter(function (tag) {
            return tag === 'hide_from_catalog'
        }).length

        if ( hasHideFlag ) {
            return '';
        }
    }

    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data.selected_or_first_available_variant;

    // TEMPLATE : Create unique tpl instance
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;


    // BADGE : ITEM TYPE : Add Item Badge (Required Tags : item_badge_text_SOMETHING + item_badge_shape_SOMETHING)
    if (data.tags) {
        var findTag = function (searchString) {
            var foundTags = data.tags.filter(function (tag) {
                return tag.indexOf(searchString) >= 0;
            });

            return foundTags || [];
        };

        // POPULATE : Build array of tags with only the ones we want
        var badgeTags = findTag('item_badge_');
        if (badgeTags.length > 0) {

            // RENDER : Drop populated badge template into itemHtml template
            var itemBadgeHtml = bcSfFilterTemplate.itemBadgeHtml; //Don't modify original :)
            itemBadgeHtml = itemBadgeHtml.replace(/{{badgeTags}}/g, JSON.stringify(badgeTags));
            itemHtml = itemHtml.replace(/{{itemBadge}}/g, itemBadgeHtml);

        } else {
            itemHtml = itemHtml.replace(/{{itemBadge}}/g, ''); //No badge, remove block
        }
    }

    // VENDOR : Display vendor if enabled
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);


    // WISHLIST BUTTON : Add wishlist button to grid item (Needs ID, so fill this before "{{itemProductId}}" )
    itemHtml = itemHtml.replace(/{{wishlistButton}}/g, bcSfFilterTemplate.wishlistBtnHtml);


    // PRICE : Add price and original price if discounted
    var itemPriceHtml = '';
    var priceObj = {
        minPrice: this.formatMoney(data.price_min, this.moneyFormat),
        maxPrice: this.formatMoney(data.price_max || 0, this.moneyFormat),
        beforeSalePrice: this.formatMoney(data.compare_at_price_min || 0, this.moneyFormat)
    };
    if(priceObj.minPrice.split('.')[1] == '00'){
        priceObj.minPrice = priceObj.minPrice.split('.')[0];
    }
    if(priceObj.maxPrice.split('.')[1] == '00'){
        priceObj.maxPrice = priceObj.maxPrice.split('.')[0];
    }
    if(priceObj.beforeSalePrice.split('.')[1] == '00'){
        priceObj.beforeSalePrice = priceObj.beforeSalePrice.split('.')[0];
    }
    if (onSale && !priceVaries) {
        itemPriceHtml += '<div class="was bfx-price">' + priceObj.beforeSalePrice + '</div>';
        itemPriceHtml += '<div class="onsale bfx-price">' + priceObj.minPrice + '</div>';

    } else {
        itemPriceHtml += '<div class="prod-price bfx-price">';

        if (priceVaries) {
            itemPriceHtml += bcSfFilterConfig.label.from_price + ' ' + priceObj.minPrice + ' - ' + priceObj.maxPrice;
        } else {
            itemPriceHtml += priceObj.minPrice;
        }
        itemPriceHtml += '</div>';
    }
    // PDM-868 : Patch for mobile Safari regex bug
    var itemPriceRegEx = new RegExp( '{{itemPrice}}', 'g'); 
    itemHtml = itemHtml.replace(itemPriceRegEx, function(match) { return itemPriceHtml }); 

    // QUICK VIEW : Add quickview template and setup for fancybox usage
    var itemQuickviewHtml = '';
    if (bcSfFilterConfig.custom.quick_view_enable) {
        itemQuickviewHtml += '<a class="fancybox.ajax product-modal product-quickview" href="{{itemUrl}}?view=quick">' + bcSfFilterConfig.label.quick_view + '</a>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickview}}/g, itemQuickviewHtml);

    // SWATCHES : Build data object for usage in react-swatches
    itemHtml = itemHtml.replace(/{{itemProductId}}/g, data.id); //Splice in product ID
        
    itemHtml = itemHtml.replace(/{{itemProductId}}/g, data.id ); //Splice in product ID
    // THUMBNAIL : Add Thumbnail template
    var itemImageHtmlCustom = '<img class="main-img" id="product-image-{{itemProductId}}" src="{{itemThumbUrl}}" alt="{{itemTitle}}" />';
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '500x') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemImageCustom}}/g, itemImageHtmlCustom);

    // IMAGE : FLIP : Add Flip Image if enabled
    var itemFlipImageHtml = '';
    if (bcSfFilterConfig.custom.image_flip || bcSfFilterConfig.custom.flip_alternate && images.length > 1) {
        itemFlipImageHtml = '<div class="hidden">';
        itemFlipImageHtml += '<img src="' + this.optimizeImage(images[1]['src'], '500x') + '" alt="{{itemTitle}}" />';
        itemFlipImageHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemFlipImage}}/g, itemFlipImageHtml);

    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    var itemSwatchHtml = '';
    if (bcSfFilterConfig.custom.alternate_colors || bcSfFilterConfig.custom.flip_alternate) {

        // UTILS : Store util methods so we can use inside iterators
        var slugify = this.slugify;
        var optimizeImage = this.optimizeImage.bind(this); //BCSF constructor needs this context to function

        // SWATCHES - DEFAULT IMAGE : Parent image that is displayed by default (used by hover states to reset)
        var productImgUrl = images.length > 0 ? optimizeImage(images[0]['src'], '500x') : bcSfFilterConfig.general.no_image_url;

        // SWATCHES - SWATCH DATA : Grab swatch data array from util method
        var swatchData = filterUtils.getSwatchesFromProduct( data, productImgUrl );

        // SWATCHES - TEMPLATE : React -> SwatchParent.js : Render swatches if multiple colors present
        if ( swatchData && swatchData.length > 0 ) {
            var swatchManifest = [];

            // NOTE : REFACTOR TO A FOR EACH AND USE NEW NORMALIED STRUCTURE!
            swatchData.forEach(function (colorObj) {

                // SWATCH IMAGE : Build swatch image, fallback to color setting in case that fails
                var colorName = slugify(colorObj.title).replace(/-/gi, '_'); //Replace slug dash for _ to support photo studio tool format
                var cleanSku = colorObj.sku.split( '-' )[0];
                var swatchFileName = cleanSku + '_' + colorName + '_sw.jpg';
                var swatchImgUrl = bcSfFilterConfig.general.swatch_replace_url.replace('swatch_url_source_do_not_remove.png', swatchFileName.toLowerCase());

                // SWATCH OBJ: Single swatch object for manifest
                var colorValueName = slugify(colorObj.title);
                var swatch = {
                    colorDisplayName: colorObj.title,           // NAME : Color Name that user sees in tooltip
                    colorValueName: colorValueName,             // NAME : CSS name for color style fallback
                    handle: colorObj.handle,                    // HANDLE : So we direct link to this product color
                    productId: data.id,                         // ID : Product ID
                    productImgUrl: productImgUrl,               // IMAGE : Product image original (for restoring after hover)
                    swatchId: data.id + '-' + colorValueName,   // ID : Swatch : Swatch Color Unique ID
                    swatchImgUrl: swatchImgUrl,                 // SWATCH : Image url for swatch (fallback = name as color)    
                    variantImgUrl: colorObj.image               // IMAGE : Product Variant Image for that color option
                }

                // MANIFEST : ADD : Add this swatch to the list
                swatchManifest.push(swatch);
            });


            // POPULATE : Render the react root element for each swatch list
            var swatchManifestString = JSON.stringify(swatchManifest);
            itemSwatchHtml = "<div class='react-swatch-list' data-swatches='" + swatchManifestString + "'></div>";

            // BUILD : Spacer : Only 1 color, render spacer instead of swatch list
        } else {
            itemSwatchHtml = "<div class='swatch-spacer'></div>";
        }
    }
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);


    // PROMO EXCLUSION : INITIAL LANDING : Note reading "Excluded from Promotion" when properly tagged
    if ( data.tags ) { // 'data.tags' here is only the parent product tags
        var tags = data.tags || [];
        var collectionHandle = bcSfFilterConfig.general.collection_handle;
        var targetTag = 'promo_exclude_' + collectionHandle;
      
        // CHECK TAGS : "promo_exclude_COLLECTION-HANDLE" (must match this collection to show)
        var hasExcludeTag = tags.filter( function( tag ) {
            return tag.indexOf( targetTag ) > -1 
        });
        var showExclude = hasExcludeTag.length > 0;

        // POPULATE : Render show state + text into template
        itemHtml = itemHtml.replace(/{{itemShowExclude}}/g, showExclude );
        itemHtml = itemHtml.replace(/{{itemLabelExclude}}/g, bcSfFilterConfig.label.exclude_note );
    }
    


    // INFO : Add main attributes for product data
    itemHtml = itemHtml.replace(/{{itemProductId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemPriceAttr}}/g, data.price_min);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));


    // RENDER : Return out our built template!
    }

    return itemHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build additional attributes of product items
BCSfFilter.miniHeightAction = function(selector) {
    var min_height = 0;
    selector.each(function() {
        var height = $(this).outerHeight();
        if (height > min_height) {
            min_height = height;
        }
    });
    return min_height;
};

BCSfFilter.miniHeight = function(parent, select) {
    var parentWrapper = $(parent).closest(".shopify-section");
    parentWrapper.each(function(index, item) {
        if ($(parent, item).length > 0) {
            var result = BCSfFilter.miniHeightAction($(select, item));
            $(parent, item).css("height", result);
        }
    });
};

BCSfFilter.prototype.buildFilterOptionMultipleListData = function(a, b, c, d, e, f, g, h) {
    if (this.checkShowFilterOptionItem(f, g)) {
        var i = f.key
          , j = f.key;
        "price" == a || "percent_sale" == a ? (j = j.replace(/\*/g, "").replace(/\-/g, ":"),
        e = "multiple") : "stock" == a && (i = f.label,
        j = "in-stock" == f.key);
        var k = this.getTemplate("filterOptionMultipleListItem");
      	k = this.buildFilterOptionItem(k, i, j, a, b, c, d, e, f, g, h)
      	if (a == 'price' && d == 'list') {
          k = k.replace("'", '"').replace(/\$/g, "&#36;")
        }
        return k
    }
    return ""
}

BCSfFilter.prototype.buildExtrasProductList = function (data) {
   
        // $('#bc-sf-filter-options-wrapper .bc-sf-filter-option-block').not('[data-selected-filter-count]').each(function(){
        //     $(this).find('.bc-sf-filter-block-content').hide();
        //     $(this).find('.bc-sf-filter-block-title h3 span').addClass('up');
        // });

    //     if(data.length > 0){

    //         let miniHeightInterval = setInterval(()=>{
    //             if($('.product-info .product-title-wrap').length > 0 && $('.product-index .prod-image').length > 0){
    //                 BCSfFilter.miniHeight('.product-info .product-title-wrap','.product-info .product-title-wrap .product-title');   
    //                 BCSfFilter.miniHeight('.product-index .prod-image','.product-index .prod-container .prod-image-link');   
    //             }
    //             clearInterval(miniHeightInterval);
    //         },1000);
    //         window.addEventListener('resize',function(){
    //             BCSfFilter.miniHeight('.product-info .product-title-wrap','.product-info .product-title-wrap .product-title');   
    //             BCSfFilter.miniHeight('.product-index .prod-image','.product-index .prod-container .prod-image-link');               
    //         });
        
    // }
    // if (window.SPR) {
    //     SPR.initDomEls();
    //     SPR.loadBadges();
    // }
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
    const isMobile = $(window).width() < 768 ? true : false;
    var ui = {
        filterHeaderText: '.bc-sf-filter-block-title span', // Text for filter headers, appending the count here
        filterSetWraps: '.bc-sf-filter-option-block-list',  //Generated by filter js, DON'T store jq dom references here
        filterTreeWrap: '#bc-sf-filter-tree',
        filterWrap: '.filter-wrap-desktop',
        collectionWrap: '#collection-product-wrap',
        resultsCount: 'results-count', // Using innerHTML, lack of # intentional
        selectedInputs: 'input.selected'
    };

    // DATA PREP : Grab initial app pass w/ filter info & store to filterUtils for subsequent manual renders for merge cases
    if ( data.filter && data.filter.options ) {
        filterUtils.updateFilterState({
            filter: data.filter,
            total_product: data.total_product
        });
    }


    // CALC : Item Counts : Adjust displayed item count to play nice with the OOS removal turned on
    var perPage = bcSfFilterConfig.custom.products_per_page;
    var total = data.total_product;
    var itemCount = data.products.length;
    var displayCount = total < perPage && itemCount < total ? itemCount : total;

    // RESULTS COUNT : Render number of results in current collection
    var resultsDiv = document.getElementById(ui.resultsCount) || {};
    if ( resultsDiv ) {
        resultsDiv.innerHTML = displayCount + " Items";
    }


    // EMPTY MSG : When no items are displayed, add the empty page messaging 
    //   (has out of box one, but doesn't show when OOS filtering turns list to 0 Items)
    if ( displayCount === 0 ) {
        $( ui.collectionWrap ).append( bcSfFilterTemplate.noItemsAvailableHtml );
    }


    // Build number of products (BoostCommerce Code)
    var currentPage = this.queryParams.page;
    var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
    var to = from + data.products.length - 1;
    jQ(this.selector.bottomPagination).find('.count').html(bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' ' + bcSfFilterConfig.label.pagination_of + ' ' + data.total_product);

    // ADD GRID PROMOS : Position grid promos with #product-loop
    jQ('#grid-promos > div').each(function () {
        if (jQ(this).attr('data-position-page') == currentPage) {
            jQ(this).clone().insertBefore(jQ('#product-loop > div').eq(parseInt(jQ(this).attr('data-position-grid')) - 1));
        }
    });

    // APPLY (MOBILE) : Filters apply on selection, "Apply" closes menu on moble.  
    var filterTreeWrap = $(ui.filterTreeWrap);
    if (filterTreeWrap) {
        filterTreeWrap.find('.mobile-apply-button-container').remove();
        filterTreeWrap.find('#mobile-filter-close').remove();
        filterTreeWrap.append(bcSfFilterTemplate.mobileApplyBtnHtml);
    }

    // HIDE 1 OPTION FILTERS : Do not show filters with one option, app doesn't seem to handle this right
    var filterData = {};
    if (data.filter) {
        filterData = window.filter = data.filter; //Update filter data with latest from API

        // Fallback, only initial API calls have filter data since its for the whole set of paginated data.
    } else {
        filterData = window.filter;
    }
    // HIDE : 'activeFilters' builds array of populated filters with 2+ props
    var filters = filterData && filterData.options ? filterData.options : [];
    var activeFilters = filters.filter(function (obj) {
        return obj.status === 'active' && obj.values && obj.values.length > 1
    });

    // TOTAL : Add data attr to determine number of filters present currently (so ipad can adjust)
    var filterWrap = $(ui.filterWrap);
    if (filterWrap.length > 0) {
        visibleFilters = activeFilters.filter(function (filter) {
            return filter.values && filter.values.length > 1;
        });
        filterWrap.attr('data-total-filter-count', visibleFilters.length);
    }


    // SWATCH FILTERS : These are the color filters, the filter app is incorrectly building the urls!
    // EX: background-image: url(//cdn.shopify.com/s/files/1/0061/8532/0512/files/swatch_url_source_do_not_remove.pngcolor_tags-black.png?v=111111);
    var filterSwatches = $('.bc-sf-filter-option-swatch-image');
    if (filterSwatches.length > 0) {

        // ITERATE : Read filter swatches in filter set
        for (var i in filterSwatches) {

            // SWATCH CHECK : Swatch has style obj, check its bg image url and clean its bug
            if (filterSwatches[i] && filterSwatches[i].style) {
                var bgUrl = filterSwatches[i].style.backgroundImage;

                // CLEAN : Remove misplaced file name rev from filter app
                if (bgUrl && bgUrl.length > 0) {
                    var cleanBgUrl = bgUrl.replace('swatch_url_source_do_not_remove.png', '');
                    filterSwatches[i].style.backgroundImage = cleanBgUrl;
                }
            }

        }
    }

    // FILTER SELECTION COUNTS : Indicates how many filters in each set are selected
    var updateFilterCounts = function () {

        // SETS : If we have them, find the selected items in each and set a data-attr for the current count
        var filterSets = $(ui.filterSetWraps) || [];
        var hasSelections = false;

        // SELECTED : Calculate which filters have selections to display an indicator
        filterSets.each(function () {
            var selections = $(this).find(ui.selectedInputs) || [];

            // COUNT : If selections, count & store to data-selected-filter-count prop
            if (selections.length > 0) {
                hasSelections = true;
                $(this).attr('data-selected-filter-count', selections.length); //SET : Parent Set Wrapper block, used by 'clear' button styles
                $(this).find(ui.filterHeaderText).attr('data-selected-filter-count', selections.length); // SET : Actual Span so CSS can read value to show
            }

            // PURGE : Remove any filter with only one value available
            var id = this.dataset.id;
            var hasMultipleValues = activeFilters.find(function (active) {
                return id && id === active.filterOptionId;
            });
            if (!hasMultipleValues) {
                $(this).remove(); // Removal means border setups on ":first-child" still behave properly
            }
        });

        // BUTTONS : ARRANGEMENT : Indicator to tel how to style "apply" button to sit with "Clear All", which admittedly had to be a bit strangely wired
        hasSelections ? (
            $(ui.filterTreeWrap).addClass('selections-active') // Selections present
        ) : (
                $(ui.filterTreeWrap).removeClass('selections-active') // No selections present
            );
    }
    updateFilterCounts(); //Invoke count update on filter update

    // adjust filter layout to support design comp
    // check if 5 filters
    // put first 2, middle 1, last 2 in separate containers
    if ($('.filter-list-desktop-wrap > div > .bc-sf-filter-option-block').length == 5) {
        $('.filter-list-desktop-wrap').addClass('filter-flex-layout');
        var filtersLeft = $('.filter-list-desktop-wrap > div > .bc-sf-filter-option-block').slice(0, 2);
        var filtersMiddle = $('.filter-list-desktop-wrap > div > .bc-sf-filter-option-block').slice(2, 3);
        var filtersRight = $('.filter-list-desktop-wrap > div > .bc-sf-filter-option-block').slice(3, 5);
        filtersLeft.wrapAll('<div class="filters-left" />');
        filtersMiddle.slice(0, 2).wrapAll('<div class="filters-middle" />');
        filtersRight.wrapAll('<div class="filters-right" />');
    }

    // SWATCHES : Trigger event emit to re-render swatches
    $.event.trigger({
        type: "collectionUpdated",
        time: new Date()
    });

    if(data.total_product == 0){
        $('.main--grid .right-sec').addClass('full');
        $('.gray-animate-bg').removeClass('gray-animate-bg');
        if(isMobile){
            $('.main--grid .filter-btn').hide();
        }
    } else {
        $('.main--grid .right-sec').removeClass('full');
    }
};

// Build Default layout
function buildDefaultLink(a, b) { var c = window.location.href.split("?")[0]; return c += "?" + a + "=" + b };
BCSfFilter.prototype.buildDefaultElements = function (a) { if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && jQ("#bc-sf-filter-bottom-pagination").length > 0) { var b = bcSfFilterConfig.general.collection_count, c = parseInt(this.queryParams.page), d = Math.ceil(b / this.queryParams.limit); if (1 == d) return jQ(this.selector.pagination).html(""), !1; if ("default" == this.getSettingValue("general.paginationType")) { var e = bcSfFilterTemplate.paginateHtml, f = ""; f = c > 1 ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1)), e = e.replace(/{{previous}}/g, f); var g = ""; g = c < d ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1)), e = e.replace(/{{next}}/g, g); for (var h = [], i = c - 1; i > c - 3 && i > 0; i--)h.unshift(i); c - 4 > 0 && h.unshift("..."), c - 4 >= 0 && h.unshift(1), h.push(c); for (var j = [], k = c + 1; k < c + 3 && k <= d; k++)j.push(k); c + 3 < d && j.push("..."), c + 3 <= d && j.push(d); for (var l = "", m = h.concat(j), n = 0; n < m.length; n++)"..." == m[n] ? l += bcSfFilterTemplate.pageItemRemainHtml : l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, l = l.replace(/{{itemTitle}}/g, m[n]), l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n])); e = e.replace(/{{pageItems}}/g, l), jQ(this.selector.pagination).html(e) } } if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && jQ(this.selector.topSorting).length > 0) { jQ(this.selector.topSorting).html(""); var o = this.getSortingList(); if (o) { var p = ""; for (var q in o) p += '<option value="' + q + '">' + o[q] + "</option>"; var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p); jQ(this.selector.topSorting).html(r); var s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting; jQ(this.selector.topSorting + " select").val(s), jQ(this.selector.topSorting + " select").change(function (a) { window.location.href = buildDefaultLink("sort_by", jQ(this).val()) }) } } };




// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = filterUtils.prepareProductData;













